//generate a constant singleton class
export class Constants {
    public static readonly InfigoURL = 'https://resources.public.infigosoftware.rocks/logo/navy_coral.png';
    public static readonly WebhookCollectorUrl = 'https://demo-iframe-api.private.infigosoftware.rocks';
}
